/**
 * CSRF protection for frontend API calls.
 * Patches `window.fetch` to add `X-Requested-With: XMLHttpRequest`
 * to all same-origin `/api/` requests.
 */

let interceptorInstalled = false

export function installCsrfFetchInterceptor(): void {
  if (typeof window === 'undefined' || interceptorInstalled) return
  interceptorInstalled = true

  const originalFetch = window.fetch.bind(window)

  window.fetch = function csrfFetch(
    input: RequestInfo | URL,
    init?: RequestInit,
  ): Promise<Response> {
    const url =
      typeof input === 'string'
        ? input
        : input instanceof URL
          ? input.pathname
          : input.url

    if (url.startsWith('/api/')) {
      const headers = new Headers(init?.headers)
      if (!headers.has('X-Requested-With')) {
        headers.set('X-Requested-With', 'XMLHttpRequest')
      }
      return originalFetch(input, { ...init, headers })
    }

    return originalFetch(input, init)
  }
}
